import ViewPadrao from "../views/ViewPadrao";
import EquipamentoMedicao from "../views/EquipamentoMedicao";

export default {
  path: "equipamento-medicao",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "equipamento-medicao-list",
      component: EquipamentoMedicao,
    },
  ],
};
